import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { FiCreditCard } from "react-icons/fi";

const PaymentDetails = ({ packageData }) => {
  const [paymentMode, setPaymentMode] = useState("COD");
  const [showAdditionalFees, setShowAdditionalFees] = useState(false);
  const navigate = useNavigate();
  const [totalPrices, setTotalPrice] = useState("");
  const [fees, setFees] = useState({
    shippingCharges: 0,
    giftWrap: 0,
    transactionFee: 0,
    discounts: 0,
  });
  const [customOrderNumber, setCustomOrderNumber] = useState("");
  const [allData, setAllData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (packageData) {
      setAllData((prevData) => ({
        ...prevData,
        ...packageData,
        receiverAddress: packageData?.address?.Recive || {}, // Fix key
      }));
    }
    console.log(packageData, "this is package data");
  }, [packageData]);

  const handleFeeChange = (e) => {
    const { name, value } = e.target;
    setFees((prevFees) => ({
      ...prevFees,
      [name]: parseFloat(value) || 0,
    }));
  };

  const handleCreateOrder = async () => {
    setIsSubmitting(true);

    const totalOrderValue =
      fees.shippingCharges + fees.giftWrap + fees.transactionFee - fees.discounts;

    const orderData = {
      ...allData,
      fees,
      paymentMode,
      customOrderNumber,
      totalOrderValue,
    };

    console.log(orderData, "order data before validation");

    // Corrected requiredFields array according to your provided orderData structure
    const requiredFields = [
      // Pickup address fields
      {
        key: orderData?.address?.Pickup?.pickupAddress?.contactName,
        label: "Pickup Contact Name",
      },
      {
        key: orderData?.address?.Pickup?.pickupAddress?.email,
        label: "Pickup Email",
      },
      {
        key: orderData?.address?.Pickup?.pickupAddress?.phoneNumber,
        label: "Pickup Phone Number",
      },
      {
        key: orderData?.address?.Pickup?.pickupAddress?.address,
        label: "Pickup Address",
      },
      {
        key: orderData?.address?.Pickup?.pickupAddress?.pinCode,
        label: "Pickup Pin Code",
      },
      {
        key: orderData?.address?.Pickup?.pickupAddress?.city,
        label: "Pickup City",
      },
      {
        key: orderData?.address?.Pickup?.pickupAddress?.state,
        label: "Pickup State",
      },

      // Receiver address fields
      { key: orderData?.receiverAddress?.contactName, label: "Receiver Contact Name" },
      { key: orderData?.receiverAddress?.email, label: "Receiver Email" },
      { key: orderData?.receiverAddress?.phoneNumber, label: "Receiver Phone Number" },
      { key: orderData?.receiverAddress?.address, label: "Receiver Address" },
      { key: orderData?.receiverAddress?.pinCode, label: "Receiver Pin Code" },
      { key: orderData?.receiverAddress?.city, label: "Receiver City" },
      { key: orderData?.receiverAddress?.state, label: "Receiver State" },

      // Products and payment
      { key: orderData?.products?.length > 0, label: "Products" },
      { key: orderData?.paymentMode, label: "Payment Mode" },
    ];

    // Validate top-level required fields
    const missingField = requiredFields.find((field) => !field.key);
    if (missingField) {
      toast.error(`${missingField.label} is required.`);
      setIsSubmitting(false);
      return;
    }

    // Validate that packageList exists and contains at least one package
    if (!Array.isArray(orderData.packageList) || orderData.packageList.length === 0) {
      toast.error("At least one package is required.");
      setIsSubmitting(false);
      return;
    }

const missingPackageIndex = orderData.packageList.findIndex((pkg) => {
  const deadWeight = Number(pkg.deadWeight);
  // Calculate volumetric weight from dimensions for validation
  const length = Number(pkg.dimensions?.length);
  const width = Number(pkg.dimensions?.width);
  const height = Number(pkg.dimensions?.height);
  const volumetricWeight = length && width && height ? (length * width * height) / 5000 : 0;

  // Calculate applicable weight as max of deadWeight, volumetricWeight, and minimum 0.5
  const applicableWeight = Math.max(deadWeight, volumetricWeight, 0.5);

  // Validate required fields are present and greater than zero
  return (
    !deadWeight ||
    !length ||
    !width ||
    !height ||
    !applicableWeight
  );
});


    if (missingPackageIndex !== -1) {
      toast.error(
        `Package #${missingPackageIndex + 1}: Dead Weight, Applicable Weight, Length, Width, and Height are required.`
      );
      setIsSubmitting(false);
      return;
    }

    // Prepare data payload to match backend schema
    const data = {
      pickupAddress: {
        contactName: orderData.address.Pickup.pickupAddress.contactName,
        email: orderData.address.Pickup.pickupAddress.email,
        phoneNumber: orderData.address.Pickup.pickupAddress.phoneNumber,
        address: orderData.address.Pickup.pickupAddress.address,
        pinCode: orderData.address.Pickup.pickupAddress.pinCode,
        city: orderData.address.Pickup.pickupAddress.city,
        state: orderData.address.Pickup.pickupAddress.state,
      },
      receiverAddress: {
        contactName: orderData.receiverAddress.contactName,
        email: orderData.receiverAddress.email,
        phoneNumber: orderData.receiverAddress.phoneNumber,
        address: orderData.receiverAddress.address,
        pinCode: orderData.receiverAddress.pinCode,
        city: orderData.receiverAddress.city,
        state: orderData.receiverAddress.state,
      },
      productDetails: orderData.products,
      packageDetails: orderData.packageList.map((pkg) => ({
        deadWeight: Number(pkg.deadWeight) || 0,
        noOfBox: Number(pkg.noOfBox) || 0,
        weightPerBox: Number(pkg.weightPerBox) || 0,
        applicableWeight: Math.max(Number(pkg.deadWeight), Number(pkg.volumetricWeight), 0.5),
        volumetricWeight: {
          length: Number(pkg.dimensions?.length) || 0,
          width: Number(pkg.dimensions?.width) || 0,
          height: Number(pkg.dimensions?.height) || 0,
          calculatedWeight: Number(pkg.volumetricWeight) || 0,
        },
      })),
      paymentDetails: {
        method: orderData.paymentMode,
        amount: orderData.totalPrice,
      },
      // commodityId: orderData.selectedCommodityId // uncomment if needed
    };

    console.log(data, "data to be sent for order creation");

    try {
      const token = Cookies.get("session");
      if (!token) {
        toast.error("No authentication token found.");
        setIsSubmitting(false);
        return;
      }

      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/order/neworder`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response.data, "response data from order creation");

      toast.success("Order created successfully");
      navigate("/dashboard/order");
    } catch (error) {
      toast.error("Something went wrong while creating the order.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="border mt-5 border-[#0CBB7D] rounded-xl p-5 bg-white hover:shadow-lg transition-shadow">
      <h2 className="text-[12px] md:text-[16px] font-[600] text-gray-700 mb-2 text-left flex items-center gap-2">
          <span className="bg-[#0CBB7D] text-white rounded-lg p-2 md:p-2">
            <FiCreditCard className="text-[12px] md:text-[16px]" />
          </span>
          Payment Details
        </h2>
      <p className="mb-2 text-black text-[12px]">
        Select Mode of Payment that your buyer has chosen for the order
      </p>

      {/* Payment Mode */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 space-y-4 md:space-y-0">
        <div className="flex flex-col sm:flex-row items-left sm:space-x-4">
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              name="paymentMode"
              value="COD"
              checked={paymentMode === "COD"}
              onChange={(e) => setPaymentMode(e.target.value)}
              className="h-4 w-4 appearance-none rounded-full border-2 border-[#0CBB7D] checked:bg-[#0CBB7D] focus:outline-none cursor-pointer"
            />
            <span className="text-black text-[12px] font-[600]">COD</span>
            <p className="text-[12px] font-[400] text-gray-500 ml-2">
              Additional charges may be applicable.
            </p>
          </div>

          <div className="flex items-center space-x-2 mt-2 sm:mt-0">
            <input
              type="radio"
              name="paymentMode"
              value="Prepaid"
              checked={paymentMode === "Prepaid"}
              onChange={(e) => setPaymentMode(e.target.value)}
              className="h-4 w-4 appearance-none rounded-full border-2 border-[#0CBB7D] checked:bg-[#0CBB7D] focus:outline-none cursor-pointer"
            />
            <span className="text-black text-[12px] font-[600]">Prepaid</span>
            <p className="text-[12px] font-[400] text-gray-500 ml-2">No additional charges.</p>
          </div>
        </div>
      </div>

      {/* Additional Fees */}
      <button
        onClick={() => setShowAdditionalFees(!showAdditionalFees)}
        className="text-[#e8cafe] text-xs mb-4 flex items-center space-x-2"
      >
        <span className="text-[#0CBB7D] hover:underline text-[12px] font-[600]">
          <span className=" hover:underline text-[12px] font-[600]">+</span>
          Add Shipping Charges, Gift Wrap, Transaction Fee
        </span>
        <span className="ml-2 text-[12px] font-[400] text-gray-500">(optional)</span>
      </button>

      {showAdditionalFees && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          {[
            "Shipping Charges",
            "Gift Wrap",
            "Transaction Fee",
            "Discounts",
          ].map((label) => {
            const key = label.toLowerCase().replace(/ /g, "");
            return (
              <div key={key} className="flex flex-col">
                <label className="text-sm mb-1 text-black">{label}</label>
                <div className="flex items-center border rounded-md">
                  <input
                    type="number"
                    name={key}
                    value={fees[key] || 0}
                    onChange={handleFeeChange}
                    className="w-full border-none px-3 py-2 text-sm focus:ring-0"
                  />
                  <span className="px-2 text-sm bg-gray-100 border-l">₹</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Finalize Order */}
      <div className="flex justify-end">
        <button
          onClick={handleCreateOrder}
          disabled={isSubmitting}
          className="bg-[#0CBB7D] text-white text-[12px] px-3 py-1.5 rounded-md shadow-lg"
        >
          {isSubmitting ? "Processing..." : "Create Order"}
        </button>
      </div>
    </div>
  );
};

export default PaymentDetails;
